export default "__VITE_ASSET__54adfbf3__"